module.exports = __webpack_public_path__ + "media/bootstrap-icons/paperclip-8628e322.svg";